<div class="flex w-full flex-col items-center gap-8">
  <h1>{{ 'login.reset_your_password' | translate }}</h1>

  <pl-loader *ngIf="isLoading"></pl-loader>
  <div class="w-full bg-pl-error p-4 text-sm italic text-white" [hidden]="!error || isLoading">
    {{ error }}
  </div>

  <form
    *ngIf="!isLoading && !showEmailSentSection"
    class="flex w-full flex-col items-center gap-4"
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="resetPassword()"
    #myForgotPasswordForm="ngForm"
  >
    <pl-input
      class="w-full"
      #plInputForgotPassword
      [formControlName]="FormControlName.email"
      [isFormSubmitted]="myForgotPasswordForm.submitted"
      [label]="'login.enter_registered_email' | translate"
      [requiredErrorMessage]="'login.errors.enter_registered_email' | translate"
      [showRightIcon]="false"
    />
    <pl-button
      class="block w-full"
      [variant]="ButtonVariant.blue"
      [padding]="ButtonPadding.big"
      [type]="PlButtonType.submit"
    >
      {{ 'login.reset_password' | translate }}
    </pl-button>

    <a class="mt-4 cursor-pointer text-lg text-pl-blue-500" (click)="showLoginScreen()">
      {{ 'login.back_to_login' | translate }}
    </a>
  </form>

  <div class="flex w-full flex-col gap-4" *ngIf="!isLoading && showEmailSentSection">
    <p class="text-lg font-bold text-pl-gray-700">{{ 'login.email_forgot_password_sent.header' | translate }}</p>
    <p class="text-lg">{{ 'login.email_forgot_password_sent.list_header' | translate }}</p>
    <ul class="ml-3.5 list-disc text-lg text-pl-gray-450">
      <li>{{ 'login.email_forgot_password_sent.list_1' | translate }}</li>
      <li>{{ 'login.email_forgot_password_sent.list_2' | translate }}</li>
      <li>{{ 'login.email_forgot_password_sent.list_3' | translate }}</li>
    </ul>

    <pl-button
      class="mt-4 block w-full"
      [variant]="ButtonVariant.blue"
      [padding]="ButtonPadding.big"
      (click)="showLoginScreen()"
    >
      {{ 'login.back_to_login' | translate }}
    </pl-button>
  </div>

  <p class="text-center text-lg text-pl-gray-450">{{ 'login.need_help_contact_support' | translate }}</p>
</div>
